const Helper = {
    isLinkOrEvent: (value) => {
        return (value.indexOf('()') <= -1);
    },
    isObjectEmpty: (obj) => {
        return Object.keys(obj).length === 0;
    },
    toLittleText: (text, len = 10) => {
        return (text.length > len) ? text.toString().substr(0, len) + '...' : text;
    },
    toCurrencyFormat: (value) => {
        return value && value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    uuid: () => {
        let dt = new Date().getTime();
        let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            let r = (dt + Math.random()*16)%16 | 0;
            dt = Math.floor(dt/16);
            return (c=='x' ? r :(r&0x3|0x8)).toString(16);
        });
        return uuid;
    },
    objectEqual: (object1, object2) => {
        let result = false;
        if (JSON.stringify(object1) === JSON.stringify(object2)) {
            result = true;
        }
        return result;
    },
    hasFile: (object) => {
        let result = false;
        for (const [key, value] of Object.entries(object)) {
            if(value instanceof File) {
                result = true;
                break;
            }
        }
        return result;
    },
    isMobile: () => {
        const toMatch = [
            /Android/i,
            /webOS/i,
            /iPhone/i,
            /iPad/i,
            /iPod/i,
            /BlackBerry/i,
            /Windows Phone/i
        ];

        return toMatch.some((toMatchItem) => {
            return navigator.userAgent.match(toMatchItem);
        });
    },
    objectSort: (object) => {
        let sorted = {},
            key, a = [];

        for (key in object) {
            if (object.hasOwnProperty(key)) {
                a.push(key);
            }
        }

        a.sort();

        for (key = 0; key < a.length; key++) {
            sorted[a[key]] = object[a[key]];
        }
        return sorted;
    },
    prePendingZero: (value) => {
        return ('0' + value).slice(-2);
    }
}

export default Helper;
